function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 22.737,
    viewBox: "0 0 21.5 22.737",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1669",
    d: "m123.616 815.283.53-.561zm3.212 3.4-.53.561zm-14.578 16.511v.793h1.5v-.793zm10 0v.793h1.5v-.793zm-1.25-15.07a.794.794 0 0 0 0-1.586zm-6-1.586a.794.794 0 0 0 0 1.586zm12.25 3.132v9.294h1.5v-9.294zM124 834.4h-12v1.586h12zm-15.25-3.437v-12.69h-1.5v12.69zm3.25-16.127h8.788v-1.586H112zm11.086 1.007 3.212 3.4 1.061-1.121-3.213-3.4zm-2.3-1.007a3.161 3.161 0 0 1 2.3 1.007l1.06-1.122a4.62 4.62 0 0 0-3.358-1.471zM112 834.4a3.347 3.347 0 0 1-3.25-3.437h-1.5a4.893 4.893 0 0 0 4.75 5.023zm15.25-3.437A3.347 3.347 0 0 1 124 834.4v1.586a4.893 4.893 0 0 0 4.75-5.023zm1.5-9.294a5.171 5.171 0 0 0-1.391-3.551l-1.059 1.122a3.538 3.538 0 0 1 .952 2.43zm-20-3.4a3.347 3.347 0 0 1 3.25-3.437v-1.582a4.893 4.893 0 0 0-4.75 5.023zm5 16.921v-6.345h-1.5v6.345zm1.25-7.667h6v-1.586h-6zm7.25 1.322v6.345h1.5v-6.345zm-1.25-1.318a1.288 1.288 0 0 1 1.25 1.322h1.5a2.832 2.832 0 0 0-2.75-2.908zm-7.25 1.322a1.288 1.288 0 0 1 1.25-1.322v-1.586a2.832 2.832 0 0 0-2.75 2.908zm7.25-10.311h-6v1.586h6z",
    transform: "translate(-107.25 -813.25)",
    style: {
      fill: "#28303f"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.6c17aa57df41ef00fc08bbc85de535eb.svg";
export { ForwardRef as ReactComponent };